import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { PublicComponent, SecureComponent } from './layouts';
import { publicRoutes, secureRoutes } from './routes';
import { SharedModule } from './shared';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { setAppInjector } from './app-injector';
import { AppInterceptorProviders } from './app.interceptor';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';
import { AppPath } from './utils/constants/paths';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SettingsService } from './apis/settings.service';
import { ReportWinloseService } from './apis/report-winlose.service';
import { setTranslateService } from './app-translate';
import { getWebConfig } from './app-web';
import { setAlertTextTranslations } from './utils/functions/alert';

export function createTranslateLoader(http: HttpClient) {
  const config = getWebConfig();
  return new TranslateHttpLoader(http, config.languageHost, '');
}

@NgModule({
  declarations: [AppComponent, PublicComponent, SecureComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot([
      {
        path: '',
        canActivateChild: [NoAuthGuard],
        component: PublicComponent,
        children: publicRoutes,
      },
      {
        path: AppPath.apiDoc,
        loadChildren: () => import('./pages').then((C) => C.ApiDocModule),
      },
      {
        path: AppPath.apiDocCallback,
        loadChildren: () => import('./pages').then((C) => C.ApiDocCallbackModule),
      },
      {
        path: AppPath.stockLottoSuperlotLogin,
        loadChildren: () => import('./pages').then((m) => m.SuperlotLoginModule),
      },
      {
        path: '',
        canActivateChild: [AuthGuard],
        component: SecureComponent,
        children: secureRoutes,
      },
      {
        path: AppPath.notFound,
        loadChildren: () => import('./pages').then((m) => m.NotFoundModule),
      },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ]),
    SharedModule,
    BrowserAnimationsModule,
    LoadingBarHttpClientModule,
    LoadingBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      defaultLanguage: 'th',
    }),
  ],
  providers: [AppInterceptorProviders, SettingsService, ReportWinloseService],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(injector: Injector, translateService: TranslateService) {
    setAppInjector(injector);
    setTranslateService(translateService);
    setAlertTextTranslations();
  }
}
